import React from 'react';

export default ({title, children, ...props}) => <div className="mobile-block" {...props}>
  {children || title}
</div>

